module.exports = __webpack_public_path__ + "img/coupon-banner.b9795ab4.jpg";